import { Row } from "antd";
import { h } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useLocation } from "react-router-dom";
import { ButtonCSV } from "../../components/button/buttonCSV";
import { PrimaryButton } from "../../components/button/primary";
import { SecondaryButton } from "../../components/button/secondary";
import Container from "../../components/container";
import { InputLabel } from "../../components/form/input/input";
import WrapperComponent from "../../components/hoc/WrapperComponent";
import { TextHeader } from "../../components/text";
import { COULMN_DATA } from "./constants/columns";
import { HEADERS } from "./constants/exportexcel";
import { SEARCH_FORM, SEARCH_FORM_DEVICE_ID } from "./constants/form";
import { useSearchData } from "./hook/useSearchData";
import { ContainerTable, DivButtonExportFile } from "./style/style";
import { TableData } from "./view/table/data";

const InvoiceScene = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const invoice = params.get("i");
  const [forceLoading, setForceLoading] = useState(true);
  const { onSearch, data } = useSearchData();
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState(invoice);
  const [deviceId, setDeviceId] = useState("")

  useEffect(() => {
    onFetchSearch();
  }, [invoice]);

  const onFetchSearch = async () => {
    (await onSearch(invoice, deviceId));
    setForceLoading(false);
  };

  const onChangeText = (e: any, item: any) => {
    const { ref } = item;
    if (ref === "search_invoice") {
      setText(`${e.target.value}`.toUpperCase());
    } else if (ref == "search_device_id") {
      setDeviceId(`${e.target.value}`.toUpperCase());
    } else {
      setText("");
      setDeviceId("");
    }
  };

  const onPress = async (i?: string | null, force?: boolean) => {
    i = i || text;
    force && setForceLoading(true);
    setLoading(true);
    window.history.replaceState(null, "", `?i=${i}`);
    await onSearch(text, deviceId);
    force && setForceLoading(false);
    setLoading(false);
  };

  const onPressClearText = async () => {
    setText("");
    setDeviceId("");
    await onSearch(invoice, deviceId);
    window.history.replaceState(null, "", `?`);
  };

  return (
    <Container>
      <TextHeader text={"S/N - Invoice"} divider={true} />
      <Row align="middle">
        <InputLabel
          item={SEARCH_FORM}
          handleChange={onChangeText}
          onEnter={onPress}
          value={text as string}
        />
        <InputLabel
          item={SEARCH_FORM_DEVICE_ID}
          handleChange={onChangeText}
          onEnter={onPress}
          value={deviceId as string}
          hasMargin={true}
        />
        <PrimaryButton
          label={"ค้นหา"}
          style={{ marginTop: "20px", marginLeft: "20px" }}
          mobileStyle={{ marginTop: "10px" }}
          tabletStyle={{ marginTop: "10px" }}
          onPress={onPress}
          isLoading={true}
          forceLoading={forceLoading}
        />
        <SecondaryButton
          label={"ล้างข้อมูล"}
          style={{ marginTop: "20px", marginLeft: "10px" }}
          mobileStyle={{ marginTop: "10px" }}
          tabletStyle={{ marginTop: "10px" }}
          onPress={onPressClearText}
          isLoading={true}
          forceLoading={forceLoading}
        />
      </Row>
      <ContainerTable>
        <DivButtonExportFile>
          <ButtonCSV
            label={"Export"}
            data={data}
            header={HEADERS}
            style={{ marginLeft: "10px" }}
            mobileStyle={{ margin: "5px" }}
            tabletStyle={{ margin: "5px" }}
            fileName={"DeviceInvoice.csv"}
          />
        </DivButtonExportFile>
        <TableData columns={COULMN_DATA()} data={data} loading={loading} />
      </ContainerTable>
    </Container>
  ) as React.ReactNode;
};

export default WrapperComponent("InvoiceScene")(InvoiceScene);
